import React, { useState } from 'react';
import { Box, Collapse, Typography, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ApplicationActionButtons from './ApplicationActionButtons';
import { formatSubmittedDate, formatLastEditedDate } from '../utils/applicationUtils';

const useStyles = makeStyles(theme => ({
	mobileCardContainer: {
		display: 'none',
		[theme.breakpoints.down('sm')]: {
			display: 'block',
			width: '100%',
			padding: theme.spacing(0, 2),
		},
	},
	mobileCard: {
		border: '1px solid #e0e0e0',
		borderRadius: theme.spacing(0.5),
		marginBottom: theme.spacing(2),
		backgroundColor: theme.palette.white,
		overflow: 'hidden',
	},
	mobileCardHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: theme.spacing(2.5, 2),
		cursor: 'pointer',
		backgroundColor: theme.palette.background.default,
	},
	mobileCardRow: {
		display: 'flex',
		borderTop: '1px solid #e0e0e0',
		padding: theme.spacing(1.25, 2),
	},
	mobileCardLabel: {
		fontWeight: theme.typography.fontWeightBold,
		minWidth: 130,
		marginRight: theme.spacing(1),
	},
	mobileCardActions: {
		borderTop: '1px solid #e0e0e0',
		padding: theme.spacing(1.5, 2),
		display: 'flex',
		gap: '8px',
	},
	toggleIcon: {
		fontSize: theme.spacing(2),
	},
}));

const getInitialExpandedRows = (applications) => {
    const initial = {};
    applications.forEach((application, index) => {
        const key = `${application?.jobOpeningGuid}-${index}`;
        initial[key] = true;
    });
    return initial;
};

const MobileApplicationList = ({ applications, onView, onEdit, onContinue }) => {
    const classes = useStyles();
    const [expandedRows, setExpandedRows] = useState(() => getInitialExpandedRows(applications));

    const toggleRow = (key) => {
        setExpandedRows(prev => ({ ...prev, [key]: !prev[key] }));
    };

    return (
        <Box className={classes.mobileCardContainer}>
            {applications.map((application, index) => {
                const key = `${application?.jobOpeningGuid}-${index}`;
                const isExpanded = !!expandedRows[key];

                return (
                    <Box key={key} className={classes.mobileCard}>
                        <Box className={classes.mobileCardHeader} onClick={() => toggleRow(key)}>
                            <Typography variant="subtitle1">{application?.positionTitle}</Typography>
                            {isExpanded ? <RemoveIcon className={classes.toggleIcon} /> : <AddIcon className={classes.toggleIcon} />}
                        </Box>
                        <Collapse in={isExpanded}>
                            <Box className={classes.mobileCardRow}>
                                <Typography className={classes.mobileCardLabel}>Company</Typography>
                                <Typography>{application?.companyName}</Typography>
                            </Box>
                            <Box className={classes.mobileCardRow}>
                                <Typography className={classes.mobileCardLabel}>Position Location</Typography>
                                <Typography>
                                    {[application?.positionCity, application?.positionState].filter(v => v).join(', ')}
                                </Typography>
                            </Box>
                            <Box className={classes.mobileCardRow}>
                                <Typography className={classes.mobileCardLabel}>Submitted Date</Typography>
                                <Typography>{formatSubmittedDate(application?.submittedDate)}</Typography>
                            </Box>
                            <Box className={classes.mobileCardRow}>
                                <Typography className={classes.mobileCardLabel}>Last Edited Date</Typography>
                                <Typography>
                                    {formatLastEditedDate(application?.lastEditedDate, application?.submittedDate)}
                                </Typography>
                            </Box>
                            <Box className={classes.mobileCardActions}>
                                <ApplicationActionButtons
                                    application={application}
                                    onView={onView}
                                    onEdit={onEdit}
                                    onContinue={onContinue}
                                />
                            </Box>
                        </Collapse>
                    </Box>
                );
            })}
        </Box>
    );
};

export default MobileApplicationList;